import { Link, useParams } from 'react-router-dom';
import { SolConversation } from './SolConversation';

/**
 * `/sol` and `/sol/c/:conversationId` — GLOBAL SOL, the ROUTE and nothing else.
 * M11 / D-041 (J-6).
 *
 * **THE SAME SOL, WITH NO PROJECT ON SCREEN.** This wrapper mounts the same
 * `SolConversation` the Project route mounts, with `currentProjectId = null`:
 * the same planner, the same conversation system, the same memory, the same
 * capabilities, cards, authorization and action safety. There is no Global
 * brain, no Global memory and no Global router of its own — a question asked
 * here travels the one Sol path with the screen context simply absent, and a
 * status change with no resolvable Project clarifies rather than guesses.
 *
 * Global-origin conversations start here (`started_context = 'global'`,
 * `project_id = null`) and the active-conversation pointer uses the existing
 * null-Project slot. A future My Day Sol and a future Global Mic enter this
 * same Global space; neither exists yet and nothing here anticipates them.
 *
 * The optional `conversationId` in the address reopens an earlier Global
 * conversation. **An identifier, not a permission**: the server loads it as
 * the caller, and another person's id simply begins a fresh conversation.
 */
export function GlobalSolScreen() {
  const { conversationId } = useParams<{ conversationId: string }>();
  return (
    <main className="cl-screen sol-screen">
      <p className="project-home-back">
        <Link className="cl-link" to="/">
          ‹ Projects
        </Link>
      </p>

      <SolConversation
        currentProjectId={null}
        currentProjectName={null}
        openConversationId={conversationId ?? null}
      />
    </main>
  );
}
